/**
 * @generated SignedSource<<dd444d24c5445f099aee5555bb55396c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type JobFooter_User$data = {
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"user_useIsClient">;
  readonly " $fragmentType": "JobFooter_User";
};
export type JobFooter_User$key = {
  readonly " $data"?: JobFooter_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobFooter_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobFooter_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsClient"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d8ada7436e1783d6ff3cd503bfdd8afd";

export default node;
